module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_d2/cv_2_pc_9e7175f01f30735edc5395999c30bb71.jpg";